enum BadgeType {
    Gray = 'Gray',
    Primary = 'Primary',
    Error = 'Error',
    Warning = 'Warning',
    Success = 'Success',
}

export default BadgeType
